module.exports = __webpack_public_path__ + "img/bsc-03.ee20e4d5.jpg";